import { T } from '../i18n'
import { type LaneRow, cleanPort, fmtPrice, laneSlug } from '../lib/rates'

/** Full-width scrolling strip of live lane rates — the thin band that closes the dark hero. */
export function RateTicker({ lanes }: { lanes: LaneRow[] }) {
  const items = lanes.filter((l) => l.price_40hc != null).slice(0, 16)
  if (items.length === 0) return null
  const loop = [...items, ...items] // duplicate for a seamless marquee

  return (
    <div className="ticker flex h-[54px] items-center border-t border-border">
      <div className="ticker-track">
        {loop.map((l, i) => (
          <T
            key={`${l.pol_code}-${l.pod_code}-${i}`}
            to={`/rates/${laneSlug(l.pol_code, l.pod_code)}`}
            className="inline-flex items-center gap-2.5 border-r border-border px-6 text-[13px] text-muted hover:text-ink"
          >
            <span className="mono text-[10px] tracking-[0.08em] text-faint">{l.carrier ?? ''}</span>
            <span className="font-medium text-ink">{cleanPort(l.pol_name, l.pol_code)}</span>
            <span className="text-faint">→</span>
            <span className="font-medium text-ink">{cleanPort(l.pod_name, l.pod_code)}</span>
            <span className="mono font-semibold text-signal tnum">{fmtPrice(l.price_40hc)}</span>
          </T>
        ))}
      </div>
    </div>
  )
}
